import { defineStore } from 'pinia'
import { computed, ref, type ComputedRef, type Ref } from 'vue'
import type { AxiosResponse } from 'axios'

import type { ReleaseNoteChangeResponseSchema, ReleaseNoteVersionResponseSchema } from '@/api/schemas/releaseNotes/releaseNotes'
import { releaseNotesService } from '@/services/releaseNotesService'

export const useReleaseNotesStore = defineStore('releaseNotes', () => {
    const latestVersionData: Ref<ReleaseNoteVersionResponseSchema | null> = ref<ReleaseNoteVersionResponseSchema | null>(null)
    const showDialog: Ref<boolean> = ref<boolean>(false)

    const sortedChanges: ComputedRef<ReleaseNoteChangeResponseSchema[]> = computed<ReleaseNoteChangeResponseSchema[]>(() => {
        const changes = latestVersionData.value?.changes || []
        return [...changes].sort((a, b) => a.sortOrder - b.sortOrder)
    })

    async function fetchLatestVersion(): Promise<AxiosResponse<ReleaseNoteVersionResponseSchema>> {
        const response = await releaseNotesService.fetchLatestVersion()
        latestVersionData.value = response?.data || null
        return response
    }

    function setShowDialog(value: boolean): void {
        showDialog.value = value
    }

    return {
        latestVersionData,
        sortedChanges,
        showDialog,
        fetchLatestVersion,
        setShowDialog
    }
})
